// extracted by mini-css-extract-plugin
export default {"toaster":"toaster_toaster__0W-Lh","success":"toaster_success__BUD3Q","error":"toaster_error__dtINl","active":"toaster_active__SoZBZ","rotate":"toaster_rotate__o9lPb"};